'use strict';

//初始化监控脚本
if (BJ_REPORT && BJ_REPORT.init) {
    try {
        BJ_REPORT.init({
            id: 3, // 上报 id, 不指定 id 将不上报
            uin: 'offical website', // 指定用户 id, (默认已经读取 qq uin)
            delay: 1000, // 当 combo 为 true 可用，延迟多少毫秒，合并缓冲区中的上报（默认）
            url: "https://fe.sunlands.com/sa/badjs", // 指定上报地址
            // ignore: [/Script error/i],            // 忽略某个错误
            random: 1, // 抽样上报，1~0 之间数值，1为100%上报（默认 1）
            repeat: 5 // 重复上报次数(对于同一个错误超过多少次不上报)
            // 避免出现单个用户同一错误上报过多的情况
        });
    } catch (e) {
        console.error('上报js脚本错误，', e);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/report.js
// module id = 94
// module chunks = 9